import { createSlice } from "@reduxjs/toolkit";
import { globalSettingsApiSlice } from "./globalSettingsApiSlice";

export const initialState = {
  query: {},
  one: {},
};

export const globalSettingsSlice = createSlice({
  name: "globalSettings",
  initialState,
  reducers: {
    setQueryValue: (state, action) => {
      if (action.payload.key) {
        state.query[action.payload.key] = action.payload.value;
      } else {
        state.query = action.payload;
      }
    },
    setOneValue: (state, action) => {
      state.one[action.payload.key] = action.payload.value;
    },
    clearOne: (state, action) => {
      state.one = initialState.one;
    },
    setOptionsValue: (state, action) => {
      if (!state.one?.options.includes(action.payload)) {
        state.one.options = [...state.one.options, action.payload];
      }
    },
    removeOptionsValue: (state, action) => {
      state.one.options = state.one.options?.filter(
        (e) => e !== action.payload
      );
    },
    setArrayTypeOptions: (state, action) => {
      if (!state.one?.value.includes(action.payload)) {
        state.one.value = [...state.one.value, action.payload];
      }
    },
    removeArrayTypeValue: (state, action) => {
      state.one.value = state.one.value?.filter((e) => e !== action.payload);
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      globalSettingsApiSlice.endpoints.loadOneDetails.matchFulfilled,
      (state, action) => {
        state.one = action.payload.data;
      }
    );
  },
});

export const {
  setOneValue,
  setQueryValue,
  clearOne,
  setOptionsValue,
  removeOptionsValue,
  setArrayTypeOptions,
  removeArrayTypeValue,
} = globalSettingsSlice.actions;

export default globalSettingsSlice.reducer;
